import Vuex from "vuex";
import Vue from "vue";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

const cookieStorage = {
  getItem: key => Cookies.get(key),
  setItem: (key, value) =>
    Cookies.set(key, value, {
      secure: false,
      sameSite: "Strict",
    }),
  removeItem: key => Cookies.remove(key),
};

// je nutné vyjmenovat, které properties se budou ukládat do cookie
const vuexCookie = new VuexPersistence({
  key: "powebStoreCookie",
  storage: cookieStorage,
  reducer: state => ({
    cartCount: state.cartCount,
    cartSum: state.cartSum,
    cartContent: state.cartContent,
    detailId: state.detailId,
    formularId: state.formularId,
    formularNazev: state.formularNazev,
    kategorieFormularu: state.kategorieFormularu,
    dlazdiceUFormularu: state.dlazdiceUFormularu,
    detailPlatbaId: state.detailPlatbaId,
    email: state.email,
    organizace: state.organizace,
    htmlError: "",
  }),
});

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    globalLoading: false,
    cartCount: 0,
    cartSum: 0,
    cartContent: [],
    cartForGoPay: null,
    cartForQr: null,
    detailId: null,
    detailPlatbaId: null,
    formularId: null,
    formularNazev: null,
    kategorieFormularu: null,
    dlazdiceUFormularu: null,
    blobPodani: null,
    blobOsvedceni: null,
    detailHrazenyPoplatek: null,
    email: null,
    organizace: [],
    logo: null,
    isHomeSelected: false,
    isPoplatkySelected: false,
    isFormulareSelected: false,
    isUhrazeneSelected: false,
    isContactsSelected: false,
    isConditionsSelected: false,
    isProtectionSelected: false,
    isCartSelected: false,
    // platbu neukládat nikam, obsahuje osobní údaje v účelu platby
    payment: null,
    htmlError: "",
  };
};

export const store = new Vuex.Store({
  state: getDefaultState(),

  mutations: {
    RESET_state: _state => {
      Object.assign(_state, getDefaultState());
    },

    // global loading
    SET_globalLoading: (_state, globalLoading) => {
      _state.globalLoading = globalLoading;
    },

    // cartContent
    SET_cartContent: (_state, cartContent) => {
      _state.cartContent = cartContent;
    },
    ADD_cartContent: (_state, id) => {
      _state.cartContent.push(id);
    },
    REMOVE_cartContent: (_state, id) => {
      var index = _state.cartContent.indexOf(id);
      _state.cartContent.splice(index, 1);
    },

    // cartCount
    SET_cartCount: (_state, cartCount) => {
      _state.cartCount = cartCount;
    },
    INCREMENT_cartCount: _state => {
      _state.cartCount += 1;
    },
    DECREMENT_cartCount: _state => {
      _state.cartCount -= 1;
    },

    // cartSum
    SET_cartSum: (_state, cartSum) => {
      _state.cartSum = cartSum;
    },
    ADD_cartSum: (_state, sum) => {
      _state.cartSum = _state.cartSum + sum;
    },
    SUB_cartSum: (_state, sum) => {
      _state.cartSum = _state.cartSum - sum;
    },

    SET_cartForGoPay: (_state, cartForGoPay) => {
      _state.cartForGoPay = cartForGoPay;
    },
    SET_cartForQr: (_state, cartForQr) => {
      _state.cartForQr = cartForQr;
    },

    // detailId
    SET_detailId: (_state, id) => {
      _state.detailId = id;
    },

    // detail platby
    SET_detailPlatbaId: (_state, platbaId) => {
      _state.detailPlatbaId = platbaId;
    },

    // detail formulare
    SET_formularId: (_state, formularId) => {
      _state.formularId = formularId;
    },

    SET_formularNazev: (_state, formularNazev) => {
      _state.formularNazev = formularNazev;
    },

    // detail formulare
    SET_kategorieFormularu: (_state, kategorieFormularu) => {
      _state.kategorieFormularu = kategorieFormularu;
    },

    SET_dlazdiceUFormularu: (_state, dlazdiceUFormularu) => {
      _state.dlazdiceUFormularu = dlazdiceUFormularu;
    },

    // osvedceni zadosti
    SET_blobPodani: (_state, blobPodani) => {
      _state.blobPodani = blobPodani;
    },

    // osvedceni zadosti
    SET_blobOsvedceni: (_state, blobOsvedceni) => {
      _state.blobOsvedceni = blobOsvedceni;
    },

    // detail hrazeneho poplatku
    SET_detailHrazenyPoplatek: (_state, poplatek) => {
      _state.detailHrazenyPoplatek = poplatek;
    },

    // email
    SET_email: (_state, email) => {
      _state.email = email;
    },

    // oganizace
    SET_organizace: (_state, organizace) => {
      _state.organizace = organizace;
    },

    // payment
    SET_payment: (_state, payment) => {
      _state.payment = payment;
    },

    // menu active items
    SET_isHomeSelected: (_state, isSelected) => {
      _state.isHomeSelected = isSelected;
    },
    SET_isPoplatkySelected: (_state, isSelected) => {
      _state.isPoplatkySelected = isSelected;
    },
    SET_isFormulareSelected: (_state, isSelected) => {
      _state.isFormulareSelected = isSelected;
    },
    SET_isUhrazeneSelected: (_state, isSelected) => {
      _state.isUhrazeneSelected = isSelected;
    },
    SET_isContactsSelected: (_state, isSelected) => {
      _state.isContactsSelected = isSelected;
    },
    SET_isConditionsSelected: (_state, isSelected) => {
      _state.isConditionsSelected = isSelected;
    },
    SET_isProtectionSelected: (_state, isSelected) => {
      _state.isProtectionSelected = isSelected;
    },
    SET_isCartSelected: (_state, isSelected) => {
      _state.isCartSelected = isSelected;
    },
    // html request error
    SET_htmlError: (_state, error) => {
      _state.htmlError = error;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET_state");
    },
    resetAndSetGlobalLoadingToTrue({ commit }) {
      commit("RESET_state");
      commit("SET_globalLoading", true);
    },
    setGlobalLoading({ commit }, globalLoading) {
      commit("SET_globalLoading", globalLoading);
    },
    setDetail({ commit }, poplatek) {
      commit("SET_detailId", poplatek.id);
    },
    setDetailPlatbaId({ commit }, platbaId) {
      commit("SET_detailPlatbaId", platbaId);
    },
    setFormularId({ commit }, formularId) {
      commit("SET_formularId", formularId);
    },
    setFormularNazev({ commit }, formularNazev) {
      commit("SET_formularNazev", formularNazev);
    },
    setKategorieFormularu({ commit }, kategorieFormularu) {
      commit("SET_kategorieFormularu", kategorieFormularu);
    },
    setDlazdiceUFormularu({ commit }, dlazdiceUFormularu) {
      commit("SET_dlazdiceUFormularu", dlazdiceUFormularu);
    },
    setDetailHrazenyPoplatek({ commit }, poplatek) {
      commit("SET_detailHrazenyPoplatek", poplatek);
    },
    setEmail({ commit }, email) {
      commit("SET_email", email);
    },
    setBlobPodani({ commit }, blobPodani) {
      commit("SET_blobPodani", blobPodani);
    },
    setBlobOsvedceni({ commit }, blobOsvedceni) {
      commit("SET_blobOsvedceni", blobOsvedceni);
    },
    setOrganizace({ commit }, organizace) {
      commit("SET_organizace", organizace);
    },
    setPayment({ commit }, payment) {
      commit("SET_payment", payment);
    },
    addToCart({ commit }, poplatek) {
      commit("ADD_cartContent", poplatek.id);
      commit("INCREMENT_cartCount");
      commit("ADD_cartSum", poplatek.castka);
    },
    removeFromCart({ commit }, poplatek) {
      commit("REMOVE_cartContent", poplatek.id);
      commit("DECREMENT_cartCount");
      commit("SUB_cartSum", poplatek.castka);
    },
    setCartContent({ commit }, poplatky) {
      commit("SET_cartCount", poplatky.length);
      var cartSum = 0;
      var ids = [];
      poplatky.forEach(poplatek => {
        cartSum += poplatek.castka;
        ids.push(poplatek.id);
      });
      commit("SET_cartSum", cartSum);
      commit("SET_cartContent", ids);
    },
    setCartForGoPay({ commit }, cartForGoPay) {
      commit("SET_cartForGoPay", cartForGoPay);
    },
    setCartForQr({ commit }, cartForQr) {
      commit("SET_cartForQr", cartForQr);
    },

    unselectMenuItems({ commit }) {
      commit("SET_isContactsSelected", false);
      commit("SET_isConditionsSelected", false);
      commit("SET_isProtectionSelected", false);
      commit("SET_isHomeSelected", false);
      commit("SET_isFormulareSelected", false);
      commit("SET_isPoplatkySelected", false);
      commit("SET_isUhrazeneSelected", false);
      commit("SET_isCartSelected", false);
    },

    selectHomeMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isHomeSelected", true);
    },
    selectPoplatkyMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isPoplatkySelected", true);
    },
    selectFormulareMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isFormulareSelected", true);
    },
    selectUhrazeneMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isUhrazeneSelected", true);
    },
    selectContactsMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isContactsSelected", true);
    },
    selectConditionsMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isConditionsSelected", true);
    },
    selectProtectionMenuItem({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isProtectionSelected", true);
    },
    selectCart({ commit, dispatch }) {
      dispatch("unselectMenuItems");
      commit("SET_isCartSelected", true);
    },
    emptyCart({ commit }) {
      commit("SET_cartContent", []);
      commit("SET_cartCount", 0);
      commit("SET_cartSum", 0);
    },
    setHtmlError({ commit }, error) {
      commit("SET_htmlError", error);
    },
  },
  getters: {

    // z předaných poplatků odfiltruje ty které již jsou v košíku
    filterByCartContent: _state => poplatky => {
      return poplatky.filter(function(e) {
        for (var i = 0; i < _state.cartContent.length; i++) {
          if (e.id == _state.cartContent[i]) {
            return false;
          }
        }
        return true;
      });
    },
    // z předaných poplatků odfiltruje ty které již nejsou v košíku
    filterByCartContentExclude: _state => poplatky => {
      return poplatky.filter(function(e) {
        for (var i = 0; i < _state.cartContent.length; i++) {
          if (e.id == _state.cartContent[i]) {
            return true;
          }
        }
        return false;
      });
    },

    isInCart: _state => id => {
      for (var i = 0; i < _state.cartContent.length; i++) {
        if (id == _state.cartContent[i]) {
          return true;
        }
      }
      return false;
    },

    isCartEmpty: _state => () => {
      return _state.cartContent.length == 0;
    },
  },
  plugins: [vuexCookie.plugin],
});
